/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { CLUSTER_AUTHENTICATION } from 'utils/constants';

export default function mapClusterInfo(selectedCluster, tenantId, clientId, clientSecret) {
  const { authentication, id } = selectedCluster;

  if (authentication === CLUSTER_AUTHENTICATION.BEARER_TOKEN) {
    return {
      clusterId: id,
      ...(tenantId && { tenantId })
    };
  } else if (authentication === CLUSTER_AUTHENTICATION.CLIENT_CREDENTIALS) {
    return {
      clusterId: id,
      credentials: { id: clientId, secret: clientSecret },
      ...(tenantId && { tenantId })
    };
  } else {
    return {
      clusterId: id
    };
  }
}
